







































import { Component, Prop, Vue } from 'vue-property-decorator';

import { EntityLocation, Sensor, Transceiver, Vat } from '@/api';
import { EntityLocationService } from '@/services/entity-location-service';
import { VatModals } from './models/vat-modals';
import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import LocationInput from '@/components/form pickers/LocationInput.vue';
import { VatSensorTypes } from './models/vat-sensor-type';
import Toast from '@/components/display/toast.vue';
import { Constants } from '@/common/Constants';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		TransceiverSuggest,
		SensorSuggest,
		LocationInput,
	},
})
export default class InstallVatModal extends Vue {
	@Prop({ required: true, type: Object })
	public vat!: Vat & {
		transceiver: Transceiver | null;
		sensors: Sensor[];
		entitylocation: EntityLocation | null;
	};

	@Prop({ required: true, type: Function })
	private onInstall!: (vat: Vat) => Promise<void>;

	public modalId: string = VatModals.INSTALL;
	public transceiverId: number | null = this.vat.transceiver?.id ?? null;
	public volumeSensor: Sensor | null =
		this.findSensor(VatSensorTypes.LIDAR) ?? this.findSensor(VatSensorTypes.RADAR);
	public stirrerSensor: Sensor | null = this.findSensor(VatSensorTypes.STIRRER);
	public vatTempSensor: Sensor | null = this.findSensor(VatSensorTypes.VAT_TEMP);
	public inletTempSensor: Sensor | null = this.findSensor(VatSensorTypes.INLET_TEMP);

	private toast: Toast = new Toast();

	public onTransceiverChanged(transceiver: Partial<Transceiver> | null): void {
		if (transceiver === null) {
			// User cleared the transceiver selection.
			this.volumeSensor = this.stirrerSensor = this.vatTempSensor = this.inletTempSensor = null;
			return;
		}
		if (!transceiver.id) {
			return;
		}
		this.transceiverId = transceiver.id;
	}

	public async installVat(): Promise<void> {
		if (
			[
				this.transceiverId,
				this.volumeSensor,
				this.stirrerSensor,
				this.vatTempSensor,
				this.inletTempSensor,
			].includes(null)
		) {
			this.toast.makeToast(
				'You must provide a transceiver and all sensors',
				'Missing properties',
				'danger',
			);
		} else {
			this.vat.sensors = [
				{ ...this.volumeSensor },
				{ ...this.stirrerSensor, type: VatSensorTypes.STIRRER },
				{ ...this.vatTempSensor, type: VatSensorTypes.VAT_TEMP },
				{ ...this.inletTempSensor, type: VatSensorTypes.INLET_TEMP },
			];
			await this.onInstall(this.vat);
		}
	}

	public dismiss(): void {
		this.$bvModal.hide(VatModals.INSTALL);
	}

	private findSensor(sensorType: string): Sensor | null {
		return this.vat.sensors.find((sensor: Sensor) => sensor.type === sensorType) ?? null;
	}
}
